import { GoalSortingMode, OrderDirection } from '@griply/types';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUp } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './sort-bar.style';

const sortOptions: { mode: GoalSortingMode; label: string }[] = [
  {
    mode: GoalSortingMode.Name,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Name}`,
  },
  {
    mode: GoalSortingMode.Progress,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Progress}`,
  },
  {
    mode: GoalSortingMode.Impact,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Impact}`,
  },
  {
    mode: GoalSortingMode.StartDate,
    label: `general.labels.goals.sort.options.${GoalSortingMode.StartDate}`,
  },
  {
    mode: GoalSortingMode.Deadline,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Deadline}`,
  },
  {
    mode: GoalSortingMode.Tasks,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Tasks}`,
  },
];

export type SortBarProps = {
  value: GoalSortingMode | undefined;
  direction: OrderDirection;
  onChange: (mode: GoalSortingMode) => void;
  onDirectionToggle: () => void;
  hideLifeArea?: boolean;
};

export const SortBar: React.FC<SortBarProps> = ({
  value,
  direction,
  onChange,
  onDirectionToggle,
  hideLifeArea,
}) => {
  const { t } = useTranslation();

  const showLifeArea = !hideLifeArea;

  const handleClick = (mode: GoalSortingMode) => {
    if (value === mode) {
      onDirectionToggle();
      return;
    }
    onChange(mode);
  };

  const onLifeArea = () => handleClick(GoalSortingMode.LifeArea);

  return (
    <Styled.Container>
      {sortOptions.map(({ mode, label }) => {
        const isActive = value === mode;
        const _onClick = () => handleClick(mode);

        return (
          <Styled.Item key={mode} $mode={mode}>
            <Styled.Button $active={isActive} onClick={_onClick}>
              <Typography variant="buttonSmall" component="span">
                {t(label)}
              </Typography>
              {isActive && (
                <Styled.DirectionIcon $desc={direction === OrderDirection.Desc}>
                  <Icon icon={ArrowUp} />
                </Styled.DirectionIcon>
              )}
            </Styled.Button>
          </Styled.Item>
        );
      })}

      {showLifeArea && (
        <Styled.Item $mode={GoalSortingMode.LifeArea}>
          <Styled.Button
            $active={value === GoalSortingMode.LifeArea}
            onClick={onLifeArea}
          >
            <Typography variant="buttonSmall" component="span">
              {t(
                `general.labels.goals.sort.options.${GoalSortingMode.LifeArea}`,
              )}
            </Typography>
            {value === GoalSortingMode.LifeArea && (
              <Styled.DirectionIcon $desc={direction === OrderDirection.Desc}>
                <Icon icon={ArrowUp} />
              </Styled.DirectionIcon>
            )}
          </Styled.Button>
        </Styled.Item>
      )}
    </Styled.Container>
  );
};
